
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index0vekUTRDdGGGj3YETfTyA1_Esxwajwpc4x6zuARjnicMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/index.vue?macro=true";
import { default as indexPSmkbTU7yq3MkVvXRmkIlvz0xe04icfNsz3bugmeScEMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/news/index.vue?macro=true";
import { default as indexn1N7veEg8HbG5E20v6qSGBNq0pVa0swe3nAwRXHw2EgMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/index.vue?macro=true";
import { default as _91slug_93vxQERv_ORkEcCONzuZbmez72FMukHKhlvqzq2k_45Dw_45IMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/news/[slug].vue?macro=true";
import { default as peoplelcEx3pnlESHEZLQ6eNi3Lqv_45_bvHXw_qPd7D9AqWWo8Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/people.vue?macro=true";
import { default as indexTMVymgwHPjeOwQ4JRDWvent2RvD08oGI8NVDWyp7KQ8Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/events/index.vue?macro=true";
import { default as publicationsn_45y2Cw_QV8JiJGv6xIUwtWVNYPkvwBj_rDYQuz_44vIMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publications.vue?macro=true";
import { default as contactnptdUG0DwdFZjMTbqlhEWvxSOnq6vsJQzi3q5i_s1uoMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/contact.vue?macro=true";
import { default as podcastDFFU3iDhWnkSDud6jDQh4nL6pR18kANy8H6skQUYskYMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/podcast.vue?macro=true";
import { default as indexxm_45LRDDGWG7OtdlWpCwm7Z5xV_45_45M4VvcwFdLqLVPoCkMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/courses/index.vue?macro=true";
import { default as indexDB8WnUuv_f407a9Vcx0Wl4O5QYpLMF9A6G9glKmlsNQMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/research/index.vue?macro=true";
import { default as index4haN7bUgS0YIuPwx6gC7zBr_45r1uOqbZzg7hFZljnxkUMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/documents/index.vue?macro=true";
import { default as _91slug_93oUOJNEDfmVMDdxBVLxTPgyeufaqAbt2mSCina_45PAkywMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/research/[slug].vue?macro=true";
import { default as about_45largeR8PQvEwETHU5KX9VMlt9PXqwEYaLLMfpDLUtNh17HtMMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/about-large.vue?macro=true";
import { default as artistic_45researchC6hIeyVinICpDa_cZ0TKktuZHur3nPKPacBGPlTJX74Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/artistic-research.vue?macro=true";
import { default as indexXcTOWT46YKntHLyETCFTwv2Djr43YuoJ0NG_45vg0ilwYMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/events/[category]/index.vue?macro=true";
import { default as _91slug_93ra9zx1YjZKHozB3DybCc38c_45Ee_5_45iIgoDyOV7zp54kMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/events/[category]/[slug].vue?macro=true";
import { default as indexzPliHZPLYby39FtOhM4kynhEwPOVDOz0OpvU3QQ6LmkMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[category]/index.vue?macro=true";
import { default as _91slug_93Z34yC5VI_HnAqU5fgjurxRPF0y6iWdcGzH4La_45eCQcsMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[category]/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index0vekUTRDdGGGj3YETfTyA1_Esxwajwpc4x6zuARjnicMeta || {},
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/news/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/news/[slug].vue")
  },
  {
    name: "about-people",
    path: "/about/people",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/people.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/events/index.vue")
  },
  {
    name: "publications",
    path: "/publications",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publications.vue")
  },
  {
    name: "about-contact",
    path: "/about/contact",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/contact.vue")
  },
  {
    name: "about-podcast",
    path: "/about/podcast",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/podcast.vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/courses/index.vue")
  },
  {
    name: "research",
    path: "/research",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/research/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/documents/index.vue")
  },
  {
    name: "research-slug",
    path: "/research/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/research/[slug].vue")
  },
  {
    name: "about-about-large",
    path: "/about/about-large",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/about-large.vue")
  },
  {
    name: "about-artistic-research",
    path: "/about/artistic-research",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/about/artistic-research.vue")
  },
  {
    name: "events-category",
    path: "/events/:category()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/events/[category]/index.vue")
  },
  {
    name: "events-category-slug",
    path: "/events/:category()/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/events/[category]/[slug].vue")
  },
  {
    name: "publication-category",
    path: "/publication/:category()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[category]/index.vue")
  },
  {
    name: "publication-category-slug",
    path: "/publication/:category()/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[category]/[slug].vue")
  }
]